function msToString(milliseconds) {
    return Math.floor(milliseconds / 1000).toFixed(1) + "s";
}

export default msToString;
